import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  dialogTitle: "",
  dialogMessage: "",
  onDialogClose: null,
  openDialog: false,
  reloadPolicyData: false,
};
export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    reloadPolicyData: (state, action) => {
      state.reloadPolicyData = action.payload;
    },
    setHPConfigChanged: (state, action) => {
      state.hpConfigChanged = action.payload.hpConfigChanged;
    },
    setOpenDialog: (state, action) => {
      state.openDialog = action.payload;
    },
    setDialogTitle: (state, action) => {
      state.dialogTitle = action.payload;
    },
    setDialogMessage: (state, action) => {
      state.dialogMessage = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setDialog: (state, action) => {
      state.openDialog = true;
      state.dialogMessage = action.payload.message;
      state.dialogTitle = action.payload.title;
      state.onDialogClose = action.payload.onClose;
    },
    resetDialog: (state) => {
      state.dialogMessage = initialState.dialogMessage;
      state.dialogTitle = initialState.dialogTitle;
      state.openDialog = initialState.openDialog;
      state.onDialogClose = initialState.onDialogClose;
    },
  },
});

export const {
  setDialogMessage,
  setDialogTitle,
  setOpenDialog,
  setLoading,
  resetDialog,
  setDialog,
  reloadPolicyData,
  setHPConfigChanged,
} = appSlice.actions;
export default appSlice.reducer;
